import React, { useEffect, useState } from "react";
import Header1 from "../common/Header1/Header1";
import * as pageRoutes from "../../pageRoutes";
import { IconSettings } from "@tabler/icons-react";
import { apiCall, healthCheckFun } from "../common/common";
import { Link, useNavigate } from "react-router-dom";
import { healthCheckApi, passThroughApi } from "../common/constants";
import { getLocalStorageValue } from "../../utils/localStorageOperations";
import CustomLink from "../common/CustomLink/CustomLink";
import Skeleton from "react-loading-skeleton";
import config from "../../config/config";

const ServerDown = () => {
    const navigate = useNavigate();
    const [countDown, setCountDown] = useState(30);
    const [loading, setLoading] = useState(false);
    const failedUrl = getLocalStorageValue('failedUrl');
    const tenant = getLocalStorageValue("tenant");

    useEffect(() => {
        if (countDown) {
            setTimeout(function(){
                setCountDown(countDown-1);
            }, 1000);
        } else {
            checkServerMaintenance();
        }
    }, [countDown]);

    const checkServerMaintenance = () => {
        setLoading(true);
        healthCheckFun(isValid => {
            setLoading(false);
            if (isValid) {
                goBackUrl();
            } else {
                window.location.reload();
            }
        });
    };

    const goBackUrl = () => {
        let backUrl = pageRoutes.homePage;
        if (failedUrl == passThroughApi) {
            window.location.href = config.pmtEndPoint;
        } else {
            navigate(backUrl);
        }
    }

    return (<>
        <div className="vh-100">
            <div className="page-container-default h-100">
                <div className="custom-container h-100">
                    <div className="d-flex align-items-center justify-content-center h-100">
                        <div className="text-center">
                            <h1 className="display-1 fw-bold text-dark"><IconSettings stroke={2} size={70} className="mb-3"/> Application Maintenance in Progress</h1>
                            <p className="fs-3 mt-3"> <span className="text-danger">We're currently refreshing data and performing routine updates to improve your experience. Estimated time to be back online: ~5 minutes <br/>Thank you for your patience. If this takes longer than expected, feel free to reach out to our customer support.</span></p>
                            <p className="fs-3 mt-3">
                                {loading ? <>
                                    <Skeleton height="100" width="100%" />
                                </> : <>
                                    {!tenant ? <button onClick={e => goBackUrl()} className="btn btn-link text-decoration-none fs-3">Click here to go back to the Homepage</button> : <></>}
                                    {countDown ? <div className="mt-1">Will check again in {countDown}</div> : <></>}
                                </>}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
};

export default ServerDown;